import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {DelMetricCB} from "../../ope/metric/DelMetricCB";
import {GetMetricInstancesCB} from "../../ope/metric/GetMetricInstancesCB";
import {ExecWM2ECB} from "../../ope/metric/ExecWM2ECB";

@Injectable({
  providedIn: 'root'
})
export class MetricOpeService extends BaseOPEService {
  public delMetric(cb: DelMetricCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getMetricInstances(cb: GetMetricInstancesCB) {
    return this.execOPE(cb);
  }

  public execWM2E(cb: ExecWM2ECB) {
    return this.execOPE(cb);
  }
}
